// extracted by mini-css-extract-plugin
export var audioPlayer = "_ub-0";